import { useContext, useMemo } from 'react';

// contexts
import { EditorContext } from '../../context/EditorContext';

// models
import {
    PushIntegrationModel,
    PushProviders,
} from '../../models/pushProvider.model';

// hooks
import usePushIntegrationsQuery from '../pushIntegrations/usePushIntegrationsQuery';

export default function useIsCustomerIOPushProvider() {
    const {
        editorDetails: { formulaType },
    } = useContext(EditorContext);
    const { data: pushIntegrations, isPending: isLoading } =
        usePushIntegrationsQuery();

    const pushProvider = useMemo<PushIntegrationModel | undefined>(() => {
        if (formulaType) {
            return pushIntegrations?.find((pushIntegration) =>
                pushIntegration.channels?.includes(formulaType),
            );
        }
    }, [formulaType, pushIntegrations]);

    const isCustomerIOPushProvider = useMemo<boolean>(() => {
        return pushProvider?.push_provider_name === PushProviders.CustomerIO;
    }, [pushProvider]);

    return { isLoading, isCustomerIOPushProvider };
}
